import UnsubscribeModalAskCustomerService from "./UnsubscribeModalAskCustomerService";
import UnsubscribeModalTryAnotherCloset from "./UnsubscribeModalTryAnotherCloset";
import UnsubscribeModalRetentionMessage from "./UnsubscribeModalRetentionMessage";

function UnsubscribeModal({ unsubscribeModalOpened, close, currentCoupon }) {
  return (
    <>
      <UnsubscribeModalAskCustomerService
        opened={unsubscribeModalOpened === "ask_customer_service"}
        close={close}
      />
      <UnsubscribeModalTryAnotherCloset
        opened={unsubscribeModalOpened === "try_another_closet"}
        close={close}
      />
      <UnsubscribeModalRetentionMessage
        opened={unsubscribeModalOpened === "unlimited_retention"}
        close={close}
        currentCoupon={currentCoupon}
      />
    </>
  );
}

export default UnsubscribeModal;
